import { Layout } from '@/components/Layout';

export default function About() {
  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12 max-w-4xl" data-testid="about-page">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8">ABOUT PRIMESTATLAB</h1>
        
        <div className="space-y-8 text-lg leading-relaxed">
          <div>
            <h2 className="text-2xl font-heading font-bold mb-4">OUR PRINCIPLE</h2>
            <p className="mb-4">Prime Stat Lab was built on one principle:</p>
            <p className="text-2xl font-bold mb-4">Data first. Emotion second.</p>
          </div>

          <div>
            <h2 className="text-2xl font-heading font-bold mb-4">OUR APPROACH</h2>
            <p className="mb-4">
              We analyze player performance through structured statistical breakdowns — recent form, long-term baselines, 
              matchup environment, usage trends, and market movement.
            </p>
            <p className="mb-4">We do not chase narratives.<br />We test them.</p>
          </div>

          <div>
            <h2 className="text-2xl font-heading font-bold mb-4">OUR MISSION</h2>
            <p className="mb-4">Our mission is simple:</p>
            <p className="mb-4">
              To provide disciplined, data-driven prop analysis that challenges assumptions and asks one question:
            </p>
            <p className="text-2xl font-bold text-primary">What Are We Missing?</p>
          </div>

          <div className="pt-8 border-t border-border">
            <h2 className="text-2xl font-heading font-bold mb-4">WHY TRUST US?</h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold">✓</span>
                <span>Transparent track record - all picks and results publicly tracked</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold">✓</span>
                <span>Data-driven methodology - no gut feelings, only statistics</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold">✓</span>
                <span>Live tracking - follow your picks in real-time during games</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent font-bold">✓</span>
                <span>Educational content - learn the process, not just the picks</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
}